module.exports = __webpack_public_path__ + "img/banner.cc0af729.jpg";